import { RELATIONSHIP_TYPES } from '~app/shared/constants/relationshipTypes.constant';
import { titleCase } from '~app/shared/functions/utils/utils.function';
import { Brand } from '../enums/brand.enum';
import { Country } from './country.model';

export interface IEmergencyContact {
  [key: string]: any;
  firstName: string;
  lastName: string;
  relationship: string;
  mailingAddress1: string;
  mailingAddress2: string;
  mailingAddress3: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  phoneNumber1: string;
  phoneType1: string;
  phoneNumber2: string;
  phoneType2: string;
  phoneNumber3: string;
  phoneType3: string;
  contactType: string;
  emailAddress: string;
  email?: string;
  emergencyOrBeneficiary?: 'B' | 'E';
}

export interface IBeneficiaryContact extends IEmergencyContact {
  percentageAllocated: number;
}

export class Profile {
  public readonly nationality?: Country;
  public readonly data: {
    addrLine1?: string;
    addrLine2?: string;
    addrLine3?: string;
    beneficiaries: [IBeneficiaryContact, IBeneficiaryContact];
    brand: 'R' | 'C' | 'A';
    businessUnit: string;
    city: string;
    country: string;
    crewMemberId: string;
    crewNationality: string;
    emailAddress: string;
    emergencyContacts: [IEmergencyContact, IEmergencyContact];
    firstName: string;
    isContractor: boolean;
    lastName: string;
    permanentPosition: string;
    timestamp?: string;
    phoneNumber?: string;
    phonePrefix?: string;
    phoneType?: string;
    postalCode?: string;
  };

  private _photoURL?: string;
  private _photo?: Blob;

  constructor(data: any, countryList: Array<Country>) {
    this.data = data;
    this.nationality = countryList.find(country => country.code === this.data.crewNationality);

    try {
      data.emergencyContacts[0].relationship = this.parseRelationship(data.emergencyContacts[0].relationship);
    } catch (error) {}

    try {
      data.emergencyContacts[1].relationship = this.parseRelationship(data.emergencyContacts[1].relationship);
    } catch (error) {}

    try {
      data.beneficiaries[0].relationship = this.parseRelationship(data.beneficiaries[0].relationship);
    } catch (error) {}

    try {
      data.beneficiaries[1].relationship = this.parseRelationship(data.beneficiaries[1].relationship);
    } catch (error) {}
  }

  public get fullName(): string {
    return titleCase(`${this.data.firstName} ${this.data.lastName}`);
  }

  public get permanentPosition(): string {
    return this.data.permanentPosition;
  }

  public get isContractor(): boolean {
    return this.data.isContractor;
  }

  public get brand(): Brand {
    switch (this.data.brand) {
      case 'A':
        return Brand.AZAMARA;
      case 'C':
        return Brand.CELEBRITY;
      case 'R':
        return Brand.RCCL;
    }
  }

  public get crewMemberId(): string {
    return this.data.crewMemberId;
  }

  public get lastName(): string {
    return this.data.lastName;
  }

  public get photo(): Blob | undefined {
    return this._photo;
  }

  public set photo(blob: Blob) {
    if (blob) {
      this._photoURL = window.URL.createObjectURL(blob);
      this._photo = blob;
    } else {
      this._photo = undefined;
      this._photoURL = undefined;
    }
  }

  public get photoURL(): string {
    return this._photoURL;
  }

  public get phoneNumber(): string {
    return this.data.phoneNumber;
  }

  public get phoneType(): string {
    return this.data.phoneType;
  }

  public get phonePrefix(): string {
    return this.data.phonePrefix;
  }

  public get postalCode(): string {
    return this.data.postalCode;
  }

  public get addrLine1(): string {
    return this.data.addrLine1;
  }
  public get addrLine2(): string {
    return this.data.addrLine2;
  }
  public get addrLine3(): string {
    return this.data.addrLine3;
  }
  public get country(): string {
    return this.data.country;
  }
  public get city(): string {
    return this.data.city;
  }

  private parseRelationship(currentValue: string): string {
    let selectionListValue = '';
    for (const type of RELATIONSHIP_TYPES) {
      if (type.toLowerCase() === currentValue.toLowerCase()) {
        selectionListValue = type;
        break;
      }
    }
    return selectionListValue;
  }
}
